// extracted by mini-css-extract-plugin
export default {"projectsContainer":"projects_projectsContainer__t3B-O"};